import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/empty-issue.png'


const _withScopeId = n => (_pushScopeId("data-v-6bc1236b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "issue_wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "empty__content" }
const _hoisted_4 = { class: "empty__banner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty__banner__content text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "You haven’t raised any issues yet."),
  /*#__PURE__*/_createElementVNode("p", null, "Raise your next issue at lightning speed.")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty__banner__img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "empty__banner__content" }
const _hoisted_8 = { class: "empty__banner__content__list" }
const _hoisted_9 = { class: "list__item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Dispute protection"),
  /*#__PURE__*/_createTextVNode(" as standard")
], -1))
const _hoisted_11 = { class: "list__item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Deposits secured "),
  /*#__PURE__*/_createElementVNode("strong", null, "in Escrow")
], -1))
const _hoisted_13 = { class: "list__item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Verified trade contractors "),
  /*#__PURE__*/_createElementVNode("strong", null, " in your local area")
], -1))
const _hoisted_15 = { class: "empty__banner__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_IssueTypeComponent = _resolveComponent("IssueTypeComponent")!
  const _component_AccessDenied = _resolveComponent("AccessDenied")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.isShowIssueType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("ul", _hoisted_8, [
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                      _hoisted_10
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                      _hoisted_12
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                      _hoisted_14
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple",
                  width: "100%",
                  onClick: $setup.onClickTogglePropertyIssueSelect
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Raise a new issue")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_IssueTypeComponent, {
          key: 1,
          isEditMode: $setup.isEditMode,
          onOnClickBackButton: $setup.onClickBackButton,
          onSwitchToIssueListTab: $setup.switchToIssueListTab
        }, null, 8, ["isEditMode", "onOnClickBackButton", "onSwitchToIssueListTab"])),
    ($setup.isShowAccessDenied)
      ? (_openBlock(), _createBlock(_component_AccessDenied, {
          key: 2,
          onOnClose: $setup.onClose
        }, null, 8, ["onOnClose"]))
      : _createCommentVNode("", true)
  ]))
}